// smoothScrollPolyfill.js (actualizado, no invasivo)
(function () {
  // Si el navegador soporta CSSOM View Scroll Behavior, no hacer nada
  if ('scrollBehavior' in document.documentElement.style) return;

  var SCROLL_TIME = 468;
  var rAF = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
  var cAF = window.cancelAnimationFrame || clearTimeout;

  function getScrollingElement() {
    return document.scrollingElement || document.documentElement;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (_) {
      return false;
    }
  }

  function ease(k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  }

  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  function smoothScroll(el, x, y) {
    var startX = el.scrollLeft;
    var startY = el.scrollTop;
    var startTime = now();
    var frameId = 0;

    function step() {
      var time = now();
      var elapsed = (time - startTime) / SCROLL_TIME;
      if (elapsed > 1) elapsed = 1;
      var value = ease(elapsed);
      el.scrollLeft = startX + (x - startX) * value;
      el.scrollTop = startY + (y - startY) * value;
      if (elapsed < 1) {
        frameId = rAF(step);
      }
    }

    frameId = rAF(step);
    return function cancel() { if (frameId) { cAF(frameId); } };
  }

  function isObject(o) { return o && typeof o === 'object'; }
  function toNumber(v, d) { v = Number(v); return isNaN(v) ? d : v; }

  var original = {
    scroll: window.scroll || window.scrollTo,
    scrollBy: window.scrollBy,
    elementScroll: (Element.prototype.scroll || Element.prototype.scrollTo),
    elementScrollBy: Element.prototype.scrollBy,
    scrollIntoView: Element.prototype.scrollIntoView
  };

  function getXYFromArg(arg, el, relative) {
    var left, top;
    if (isObject(arg)) {
      left = toNumber(arg.left, relative ? 0 : (el.scrollLeft || 0));
      top = toNumber(arg.top, relative ? 0 : (el.scrollTop || 0));
    } else {
      // arg, arg2 form
      var a0 = arguments[0];
      var a1 = arguments[3]; // here a1 is passed explicitly when needed
      left = toNumber(a0, relative ? 0 : (el.scrollLeft || 0));
      top = toNumber(a1, relative ? 0 : (el.scrollTop || 0));
    }
    return { left: left, top: top };
  }

  function wantsSmooth(arg) {
    return isObject(arg) && String(arg.behavior) === 'smooth';
  }

  // window.scroll / window.scrollTo
  window.scroll = window.scrollTo = function () {
    var se = getScrollingElement();
    var arg0 = arguments[0];
    var arg1 = arguments[1];
    if (!isObject(arg0) && arg0 === undefined) return;

    if (!wantsSmooth(arg0) || prefersReducedMotion()) {
      // Delegar al nativo (mantener semántica cuando no se pide smooth)
      return original.scroll.apply(window, arguments);
    }

    var xy = isObject(arg0) ? getXYFromArg(arg0, se, false) : { left: toNumber(arg0, 0), top: toNumber(arg1, 0) };
    smoothScroll(se, xy.left, xy.top);
  };

  // window.scrollBy
  window.scrollBy = function () {
    var se = getScrollingElement();
    var arg0 = arguments[0];
    var arg1 = arguments[1];
    if (!wantsSmooth(arg0) || prefersReducedMotion()) {
      return original.scrollBy.apply(window, arguments);
    }
    var baseLeft = se.scrollLeft;
    var baseTop = se.scrollTop;
    var dxy = isObject(arg0) ? getXYFromArg(arg0, se, true) : { left: toNumber(arg0, 0), top: toNumber(arg1, 0) };
    smoothScroll(se, baseLeft + dxy.left, baseTop + dxy.top);
  };

  // Element.prototype.scroll / scrollTo
  var proto = Element.prototype;
  proto.scroll = proto.scrollTo = function () {
    var arg0 = arguments[0];
    var arg1 = arguments[1];
    if (!wantsSmooth(arg0) || prefersReducedMotion()) {
      return original.elementScroll ? original.elementScroll.apply(this, arguments) : (this.scrollLeft = toNumber(arg0 && arg0.left !== undefined ? arg0.left : arg0, this.scrollLeft), this.scrollTop = toNumber(arg0 && arg0.top !== undefined ? arg0.top : arg1, this.scrollTop));
    }
    var xy = isObject(arg0) ? getXYFromArg(arg0, this, false) : { left: toNumber(arg0, this.scrollLeft), top: toNumber(arg1, this.scrollTop) };
    smoothScroll(this, xy.left, xy.top);
  };

  // Element.prototype.scrollBy
  proto.scrollBy = function () {
    var arg0 = arguments[0];
    var arg1 = arguments[1];
    if (!wantsSmooth(arg0) || prefersReducedMotion()) {
      return original.elementScrollBy ? original.elementScrollBy.apply(this, arguments) : (this.scrollLeft += toNumber(isObject(arg0) ? arg0.left : arg0, 0), this.scrollTop += toNumber(isObject(arg0) ? arg0.top : arg1, 0));
    }
    var dxy = isObject(arg0) ? getXYFromArg(arg0, this, true) : { left: toNumber(arg0, 0), top: toNumber(arg1, 0) };
    smoothScroll(this, this.scrollLeft + dxy.left, this.scrollTop + dxy.top);
  };

  // Element.prototype.scrollIntoView
  proto.scrollIntoView = function () {
    var arg0 = arguments[0];
    if (!wantsSmooth(arg0) || prefersReducedMotion()) {
      return original.scrollIntoView.apply(this, arguments);
    }

    var scrollableParent = findScrollableParent(this);
    var parentRects = scrollableParent.getBoundingClientRect();
    var clientRects = this.getBoundingClientRect();
    if (scrollableParent !== getScrollingElement()) {
      smoothScroll(
        scrollableParent,
        scrollableParent.scrollLeft + clientRects.left - parentRects.left,
        scrollableParent.scrollTop + clientRects.top - parentRects.top
      );
    } else {
      var se = getScrollingElement();
      smoothScroll(se, se.scrollLeft + clientRects.left, se.scrollTop + clientRects.top);
    }
  };

  function findScrollableParent(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      var style = window.getComputedStyle(el);
      var overflow = (style.overflow + style.overflowY + style.overflowX);
      if (/(auto|scroll)/.test(overflow)) return el;
      el = el.parentNode;
    }
    return getScrollingElement();
  }
})();